<article
  class="overflow-hidden rounded-xl border bg-white shadow-header"
  [attr.aria-label]="'Signer ' + (signer.name || 'Unknown')"
>
  <header class="border-b px-5 py-4 flex items-center">
    <h4 class="m-0 text-base font-bold text-midnight line-clamp-2 flex-grow">
      {{ signer.name || '—' }}
    </h4>
    @if (!isFinalized) {
    <div class="flex items-center gap-2">
      <button
        class="btn btn-xs btn-outline normal-case rounded-full btn-error"
        (click)="onDeleteSigner()"
      >
        Delete
      </button>
      <button
        class="btn btn-xs btn-outline normal-case rounded-full"
        (click)="onEditSigner()"
      >
        Edit
      </button>
    </div>
    }
  </header>
  <div class="grid gap-x-8 gap-y-4 p-5 grid-cols-2">
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >State</span
      >
      <span class="text-sm text-midnight">{{ signer.state || '—' }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Address</span
      >
      <span class="text-sm text-midnight line-clamp-4">{{
        signer.address || '—'
      }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >IP Address</span
      >
      <span class="text-sm text-midnight line-clamp-4">{{
        signer.ipAddress || '—'
      }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Identification</span
      >
      <span class="text-sm text-midnight">{{
        identificationMethod || '—'
      }}</span>
    </div>
    <!-- Identification cards -->
    @if (signer.identificationMethod === 'identification_cards') {
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >ID type</span
      >
      <span class="text-sm text-midnight">{{ signer.idType || '—' }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >ID number</span
      >
      <span class="text-sm text-midnight">{{ signer.idNumber || '—' }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >ID issued</span
      >
      <span class="text-sm text-midnight">{{
        signer.utcIdIssuedOn | date : 'mediumDate'
      }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >ID expires</span
      >
      <span class="text-sm text-midnight">{{
        signer.utcIdExpiresOn | date : 'mediumDate'
      }}</span>
    </div>
    }

    <!-- Credible witnesses -->
    @if (signer.identificationMethod === 'credible_witnesses') {
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Witness name</span
      >
      <span class="text-sm text-midnight">{{ signer.witnessName || '—' }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Witness ID type</span
      >
      <span class="text-sm text-midnight">{{
        signer.witnessIdType || '—'
      }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Witness ID number</span
      >
      <span class="text-sm text-midnight">{{
        signer.witnessIdInfo || '—'
      }}</span>
    </div>
    }

    <!-- Personal knowledge -->
    @if (signer.identificationMethod === 'personal_knowledge') {
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Personal knowledge statement</span
      >
      <span class="text-sm text-midnight">{{
        signer.personalKnowledgeStatement || '—'
      }}</span>
    </div>
    }
    <!-- Signature -->
    @if (!hideSignatures) {
    <div class="flex flex-col justify-start gap-1">
      <div class="flex items-center gap-2">
        <span
          class="text-xs font-semibold uppercase tracking-wide text-light flex-grow"
          >Signature</span
        >
        @if (signer.signatures[0] && !isFinalized) {
        <button
          class="btn btn-xs btn-outline normal-case rounded-full btn-error"
          (click)="onDeleteSignature()"
        >
          Delete
        </button>
        <button
          class="btn btn-xs btn-outline normal-case rounded-full"
          (click)="onAddEditSignature()"
        >
          Edit
        </button>
        }
      </div>
      @if (signer.signatures[0]?.signatureImg; as imgSrc) {
      <img
        [src]="imgSrc"
        alt="Signature"
        class="m-0 h-[75px] w-auto object-contain ml-0 mr-auto"
      />
      } @else if (!isFinalized) {
      <button
        class="btn btn-xs btn-primary normal-case rounded-full w-fit flex items-center gap-1 my-2"
        (click)="onAddEditSignature()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-4 h-4"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 4.5v15m7.5-7.5h-15"
          />
        </svg>

        <span>Add signature</span>
      </button>
      }
    </div>
    }
  </div>
</article>

<!-- Delete signer modal template -->
<ng-template #deleteSignerModal>
  <div class="flex flex-col gap-6">
    <!-- Header -->
    <div class="flex items-center justify-between">
      <h3 class="flex items-center gap-3 text-lg font-bold">Delete signer</h3>
      <button class="self-start" mat-dialog-close>
        <img src="assets/icons/close.svg" alt="Close" width="16" height="16" />
      </button>
    </div>
    <!-- Message -->
    <div>
      <p>
        Are you sure you want to delete
        <strong>{{ signer.name || '—' }}</strong
        >?
      </p>
      <p>
        This also deletes any journal entries linked to this signer. This action
        cannot be undone.
      </p>
    </div>
    <!-- Buttons -->
    <div class="flex justify-center items-center gap-4">
      <button
        matDialogClose
        [disabled]="isDeletingSigner()"
        class="normal-case h-10 min-h-[40px] rounded-full btn btn-outline min-w-[160px] text-base"
      >
        Cancel
      </button>
      <button
        (click)="deleteSigner()"
        class="normal-case h-10 min-h-[40px] rounded-full btn btn-primary min-w-[160px] text-base"
      >
        @if (isDeletingSigner()) {
        <et-atoms-spinner size="small"></et-atoms-spinner>
        } @else { Delete }
      </button>
    </div>
  </div>
</ng-template>

<!-- Delete signature modal template -->
<ng-template #deleteSignatureModal>
  <div class="flex flex-col gap-6">
    <!-- Header -->
    <div class="flex items-center justify-between">
      <h3 class="flex items-center gap-3 text-lg font-bold">
        Delete signature
      </h3>
      <button class="self-start" mat-dialog-close>
        <img src="assets/icons/close.svg" alt="Close" width="16" height="16" />
      </button>
    </div>
    <!-- Message -->
    <div>
      <p>Are you sure you want to delete this signature?</p>
      <p>This action cannot be undone.</p>
    </div>
    <!-- Buttons -->
    <div class="flex justify-center items-center gap-4">
      <button
        [disabled]="isDeletingSignature()"
        matDialogClose
        class="normal-case h-10 min-h-[40px] rounded-full btn btn-outline min-w-[160px] text-base"
      >
        Cancel
      </button>
      <button
        (click)="deleteSignature()"
        class="normal-case h-10 min-h-[40px] rounded-full btn btn-primary min-w-[160px] text-base"
      >
        @if (isDeletingSignature()) {
        <et-atoms-spinner size="small"></et-atoms-spinner>
        } @else { Delete }
      </button>
    </div>
  </div>
</ng-template>
